import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import { connect } from 'react-redux';
import React from 'react';

import { mensagemAlertaActions } from '../redux';

const MensagemAlerta = (props) => {
  const handleClose = () => {
    props.ocultar();
  };
  const classes = useStyles();
  const classe = props.tipo === 'erro' ? classes.erro : classes.sucesso;

  return (
    <Snackbar
      className='sucesso'
      classes={{ root: classe }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={props.exibeNotificacao}
      ContentProps={{ 'aria-describedby': 'message-id', classes: { root: classe } }}
      message={<span id='message-id'>{props.mensagem}</span>}
      autoHideDuration={7000}
      onClose={handleClose}
      ClickAwayListenerProps={{
        mouseEvent: false,
      }}
      action={[
        <IconButton key='close' aria-label='Close' color='inherit' onClick={handleClose}>
          <CloseIcon />
        </IconButton>,
      ]}
    />
  );
};

const useStyles = makeStyles((theme) => ({
  sucesso: {
    backgroundColor: '#BF43AB',
  },
  erro: {
    backgroundColor: 'rgb(49, 49, 49);',
  },
}));

const mapStateToProps = (state) => {
  return {
    mensagem: state.notificacao.mensagem,
    tipo: state.notificacao.tipo,
    exibeNotificacao: state.notificacao.exibeNotificacao,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    ocultar: () => dispatch(mensagemAlertaActions.ocultarNotificacao()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MensagemAlerta);
